<template>
  <div class="content-list">
    <template v-if="loading">
      <div
        v-for="n in 1"
        :key="n"
        class="content-list-items"
      >
        <slot :item="{}"/>
      </div>
    </template>
    <template v-else-if="items.length > 0">
      <div
        v-for="item in items"
        :key="item.id"
        class="content-list-items"
      >
        <slot :item="item"/>
      </div>
    </template>
    <div v-else>
      No items found.
    </div>
  </div>
</template>

<script>
  export default {
    name: 'list',
    props: {
      items: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        required: true
      }
    },
  }
</script>

<style scoped lang="scss">
@import '~@scss/custom.scss';

.content-list {
  .content-list-items {
    &:not(:last-child) {
      border-bottom:1px solid;
      padding-bottom: 1.5em;
      margin-bottom: 1.5em;
      border-color:var(--main-border-color);
    }

   ::v-deep .product-item {
      border-bottom: 0;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}

</style>
